import { useTranslation } from "react-i18next";

import { InformationCarousel } from "@aviary/components/InformationCarousel";
import { NewCarousel } from "@aviary/components/NewCarousel";
import { useFlippers } from "@shared/context/FlippersContext";
import { l } from "@unauthenticated/signupSignin/locales/i18n";

import * as styles from "./StoreSignupInCarousel.styles";

interface Props {
  storeName: string;
}

const StoreSignupInCarousel = ({ storeName }: Props) => {
  const [isVanguardUhCustomExperienceEnabled] = useFlippers("vanguard_uh_custom_experience");
  const { t } = useTranslation();

  return (
    <div css={styles.carouselContainer}>
      <InformationCarousel>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide1)}
        </NewCarousel.Item>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide2)}
        </NewCarousel.Item>
        <NewCarousel.Item>
          {t(l.patientRxAuth.storeLandingPages.leftColumn.carousel.slide3)}
        </NewCarousel.Item>
        {!!isVanguardUhCustomExperienceEnabled && (
          <NewCarousel.Item>
            {t(l.UH.storeLandingPages.leftColumn.carousel.slide4, {
              storeName,
              interpolation: { escapeValue: false },
            })}
          </NewCarousel.Item>
        )}
      </InformationCarousel>
    </div>
  );
};

export { StoreSignupInCarousel };
